import React from 'react';
import { Button } from '@mui/material';
import { getNavButtonStyles } from '../styles/NavBarStyles';

export const NavButton = ({ label, onClick, isActive = false, endIcon }) => {
  return (
    <Button 
      color="inherit" 
      onClick={onClick} 
      sx={getNavButtonStyles(isActive)}
      endIcon={endIcon}
    >
      {label}
    </Button>
  );
};
